import { useContent } from "../../../context/ContentContext";
import { Editable } from "../../../context/design";

export default function DetailsSection() {
  const { details } = useContent();

  const cards = [
    { id: "wann", label: "Wann", icon: "ri-calendar-line", title: details.wann_title, text: details.wann_text, info: details.wann_info, infoIcon: "ri-time-line" },
    { id: "wo", label: "Wo",   icon: "ri-video-chat-line", title: details.wo_title,   text: details.wo_text,   info: details.wo_info,   infoIcon: "ri-wifi-line" },
    { id: "mitwem", label: "Mit wem", icon: "ri-user-smile-line", title: details.mitwem_title, text: details.mitwem_text, info: details.mitwem_info, infoIcon: "ri-award-line" },
  ];

  return (
    <section id="details" className="relative py-20 md:py-32 w-full bg-white">
      <div className="w-full px-4 sm:px-6 lg:px-12 xl:px-20">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16 md:mb-24">
            <Editable as="h2" id="details.title" label="Überschrift" className="text-3xl sm:text-4xl md:text-5xl font-bold text-sky-950 leading-tight mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
              {details.title}
            </Editable>
            <Editable as="p" id="details.subtitle" label="Untertitel" className="text-lg text-sky-700/80">{details.subtitle}</Editable>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {cards.map((card) => (
              <div key={card.label} className="relative bg-gradient-to-br from-sky-50 to-white rounded-3xl p-8 md:p-10 border border-sky-100">
                <div className="absolute -top-4 left-8 px-4 py-1 bg-sky-800 text-white text-sm font-medium rounded-full">
                  {card.label}
                </div>
                <div className="mt-4">
                  <div className="w-14 h-14 bg-sky-100 rounded-2xl flex items-center justify-center mb-6">
                    <i className={`${card.icon} text-2xl text-sky-700`}></i>
                  </div>
                  <Editable as="h3" id={`details.${card.id}_title`} label={`${card.label} – Überschrift`} className="text-xl font-bold text-sky-900 mb-3">{card.title}</Editable>
                  <Editable as="p" id={`details.${card.id}_text`} label={`${card.label} – Text`} className="text-sky-700/80 leading-relaxed mb-4">{card.text}</Editable>
                  <div className="inline-flex items-center gap-2 text-sm text-sky-600 font-medium">
                    <i className={card.infoIcon}></i>
                    <Editable as="span" id={`details.${card.id}_info`} label={`${card.label} – Info`}>{card.info}</Editable>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
